import { Controller } from 'react-hook-form'
import classNames from 'classnames'
import NumberFormat from 'react-number-format'

export default function EditNumberCell({
  rowData,
  dataKey,
  register,
  control,
  errors,
  isEdit,
  onChangeValue,
  required,
  disabled,
  ...props
}) {
  //const editing = rowData.status === 'EDIT'
  let value = rowData[dataKey] ? rowData[dataKey].toLocaleString() : 0
  //const _id = rowData.id

  let keyName = `${dataKey}_${rowData.id}`

  return (
    <span {...props} className={isEdit ? 'table-content-editing' : ''}>
      {isEdit && rowData[dataKey] != undefined ? (
        <Controller
          name={keyName}
          control={control}
          defaultValue={rowData[dataKey]}
          rules={required ? required : { required: 'กรุณากรอกจำนวนเงิน' }}
          render={(props) => {
            return (
              <NumberFormat
                className={classNames('rs-input', errors[keyName] && 'is-error')}
                thousandSeparator={true}
                value={props.value}
                disabled={disabled}
                onValueChange={(value) => {
                  props.onChange(value.floatValue)
                  onChangeValue(value.floatValue, rowData.id)
                }}
              />
            )
          }}
        />
      ) : (
        <span>{value}</span>
      )}
    </span>
  )
}
